export default "__VITE_ASSET__C3SPEMbD__"